import { Action } from '@ngrx/store';

export enum DiscrepancyActionTypes {
  DiscrepancyDownload = '[API] Download discrepancy',
  DiscrepancyDownloadSuccess = '[API] Download discrepancy success',
  DiscrepancyDownloadFail = '[API] Download discrepancy fail',
  SelectProvider = '[ProviderPage] Select Provider',

  GetFileLink = '[Discrepancies] Get file link',
  UploadFile = '[Discrepancies] Upload file',
  UploadFileFail = '[Discrepancies] Upload file failed',
  UploadFileSuccess = '[Discrepancies] Upload file success',

  ProcessDiscrepancyFile = '[Discrepancies] Update file and start processing on API',
  ProcessDiscrepancyFileUpdate = '[Discrepancies] Update file processing status',
  ProcessDiscrepancyFileSuccess = '[Discrepancies] Discrepancies file processed',

  ClearChanges = '[Discrepancies] Clear changes to update',
  AcceptChanges = '[Discrepancies] Accept all changes',
  AcceptChangesUpdate = '[Discrepancies] Discrepancies accept process update',
  AcceptChangesFail = '[Discrepancies] Changes update failed',
  AcceptChangesSuccess = '[Discrepancies] Updated changes success',

  AcceptGlobalChangesUpdate = '[Discrepancies] Discrepancies global accept process update',
  AcceptGlobalChangesFail = '[Discrepancies] Changes global update failed',
  AcceptGlobalChangesSuccess = '[Discrepancies] Updated global changes success',
}

export class DiscrepancyDownload implements Action {
  readonly type = DiscrepancyActionTypes.DiscrepancyDownload;
  constructor(public ProviderId: number, public filename: string) { }
}

export class DiscrepancyDownloadSuccess implements Action {
  readonly type = DiscrepancyActionTypes.DiscrepancyDownloadSuccess;
  constructor() { }
}

export class DiscrepancyDownloadFail implements Action {
  readonly type = DiscrepancyActionTypes.DiscrepancyDownloadFail;
  constructor(public error: any) { }
}

export class GetFileLink implements Action {
  readonly type = DiscrepancyActionTypes.GetFileLink;
  constructor(
    public FollowId: number,
    public ProviderId: number,
    public file: any,
    public followType: any,
    public OriginId?: any
  ) { }
}

export class UploadFile implements Action {
  readonly type = DiscrepancyActionTypes.UploadFile;
  constructor(public data: any, public file: any, public followType: any, public OriginId?: any) { }
}

export class UploadFileSuccess implements Action {
  readonly type = DiscrepancyActionTypes.UploadFileSuccess;
  constructor(public data: any, public followType?: any, public OriginId?: any) { }
}

export class UploadFileFail implements Action {
  readonly type = DiscrepancyActionTypes.UploadFileFail;
  constructor(public error: any) { }
}

export class ProcessDiscrepancyFile implements Action {
  readonly type = DiscrepancyActionTypes.UploadFileFail;
  constructor(public file: any) { }
}

export class ProcessDiscrepancyFileUpdate implements Action {
  readonly type = DiscrepancyActionTypes.ProcessDiscrepancyFileUpdate;
  constructor(public data: any) { }
}

export class ProcessDiscrepancyFileSuccess implements Action {
  readonly type = DiscrepancyActionTypes.ProcessDiscrepancyFileSuccess;
  constructor(public data: any) { }
}

export class ClearChanges implements Action {
  readonly type = DiscrepancyActionTypes.ClearChanges;
  constructor() { }
}

export class AcceptChanges implements Action {
  readonly type = DiscrepancyActionTypes.AcceptChanges;
  constructor(public FileId: string) { }
}

export class AcceptChangesFail implements Action {
  readonly type = DiscrepancyActionTypes.AcceptChangesFail;
  constructor(public error: any) { }
}

export class AcceptChangesUpdate implements Action {
  readonly type = DiscrepancyActionTypes.AcceptChangesUpdate;
  constructor(public data: any) { }
}

export class AcceptChangesSuccess implements Action {
  readonly type = DiscrepancyActionTypes.AcceptChangesSuccess;
  constructor(public data: any) { }
}

export class SelectProvider implements Action {
  readonly type = DiscrepancyActionTypes.SelectProvider;
  constructor(public ProformaId: number) { }
}


export class AcceptGlobalChangesUpdate implements Action {
  readonly type = DiscrepancyActionTypes.AcceptGlobalChangesUpdate;
  constructor(public data: any) { }
}

export class AcceptGlobalChangesSuccess implements Action {
  readonly type = DiscrepancyActionTypes.AcceptGlobalChangesSuccess;
  constructor(public data: any) { }
}

export class AcceptGlobalChangesFail implements Action {
  readonly type = DiscrepancyActionTypes.AcceptGlobalChangesFail;
  constructor(public error: any) { }
}


export type DiscrepancyActionsUnion =
  | DiscrepancyDownload
  | DiscrepancyDownloadSuccess
  | DiscrepancyDownloadFail
  | SelectProvider
  | GetFileLink
  | UploadFile
  | UploadFileFail
  | UploadFileSuccess
  | ProcessDiscrepancyFile
  | ProcessDiscrepancyFileUpdate
  | ProcessDiscrepancyFileSuccess
  | AcceptChanges
  | AcceptChangesFail
  | AcceptChangesSuccess
  | AcceptChangesUpdate
  | ClearChanges
  | AcceptGlobalChangesUpdate
  | AcceptGlobalChangesSuccess
  | AcceptGlobalChangesFail;
